import CreditsInfoModal from './CreditsInfoModal';

export default CreditsInfoModal;
